var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('TableWrapper',{attrs:{"columns":_vm.columns,"url":_vm.url,"search-form-fields":_vm.formFields,"offset-height":_vm.offsetHeight,"show-add":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }